// 3rd party
import * as React from 'react';

// Shared UI
import { LocalizedText } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkIcon } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';

// Models
import { Product } from 'models';

interface WidgetCodeGuideLinkProps {
  product: Product;
  onLinkClick?: () => void;
}

const WidgetCodeGuideLink = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function WidgetCodeGuideLink(props: WidgetCodeGuideLinkProps): JSX.Element {
    const { product, onLinkClick } = props;

    const handleLinkClick = () => {
      onLinkClick?.();
    };

    return (
      // <UitkLink inline={true} analytics={trackImplementationGuideLink}>
      <UitkLink inline={true} onClick={handleLinkClick}>
        <a href={product.guideLink} target="_blank" rel="noreferrer">
          <LocalizedText message="product.widget.code.implementation_guide" />
          <UitkIcon name="open_in_new" />
        </a>
      </UitkLink>
    );
  },
);

export { WidgetCodeGuideLink };
